import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ASSESSOR_ASSIGNMENTS_FEATURE_KEY } from './keys';
import { assessorAssignmentsReducer } from './reducers/assessor-assignments.reducer';
import { AssessorAssignmentsEffects } from './effects/assessor-assignments.effects';

export function provideAssessorAssignmentsStore(): EnvironmentProviders[] {
    return [provideState(ASSESSOR_ASSIGNMENTS_FEATURE_KEY, assessorAssignmentsReducer), provideEffects(AssessorAssignmentsEffects)];
}
